import { getClassScheduleTimeLabel } from '@utils/scheduleTimeDisplay';

const EXCERPT_MAX = 120;

/** Scheduled Thursday time label for a class. */
export function getScheduledTimeLabel(
  cls: Parameters<typeof getClassScheduleTimeLabel>[0]
): string | null {
  return getClassScheduleTimeLabel(cls);
}

/** User-facing class price (no payment/contact details). */
export function formatClassPriceLabel(priceTotal: number | undefined): string | null {
  if (priceTotal == null) {
    return null;
  }
  if (priceTotal === 0) {
    return 'Free';
  }
  return `$${priceTotal.toFixed(2)}`;
}

/** Short teaser for cards; prefers catalog excerpt. */
export function buildClassExcerpt(excerpt: string | undefined, description: string | undefined): string {
  const trimmedExcerpt = excerpt?.trim();
  if (trimmedExcerpt) {
    return trimmedExcerpt;
  }
  const desc = description?.trim() ?? '';
  if (!desc) {
    return '';
  }
  if (desc.length <= EXCERPT_MAX) {
    return desc;
  }
  return `${desc.slice(0, EXCERPT_MAX).trim()}…`;
}
